<div class="numeric-box" [ngClass]="{ 'numeric-box-disabled': !editable }">
  <img
    [ngClass]="{
      'numeric-box-operation': editable,
      'numeric-box-operation-disabled': !editable,
    }"
    src="assets/images/common/minus.svg"
    (click)="countDown()"
  />
  <div class="line"></div>

  <div class="numeric-box-input">
    <input
      [ngClass]="{ 'disabled-input': !editable }"
      type="number"
      [value]="value"
      readonly="readonly"
      (blur)="onTouched()"
    />
  </div>
  <div class="line"></div>

  <img
    [ngClass]="{
      'numeric-box-operation': editable,
      'numeric-box-operation-disabled': !editable,
    }"
    src="assets/images/common/plus.svg"
    (click)="countUp()"
  />
</div>
